import { twMerge } from "tailwind-merge";

// biome-ignore lint/suspicious/noExplicitAny: general use
type ClassValue = Record<string, any> | string | undefined;

function cn(...classList: ClassValue[]): string {
	return twMerge(
		classList
			.flat()
			.map((item) => {
				if (!item) {
					return "";
				}

				if (typeof item === "object") {
					return Object.entries(item)
						.map(([key, value]) => (value ? key : ""))
						.join(" ");
				}

				return item;
			})
			.join(" ")
			.trim(),
	);
}

export { cn, type ClassValue };
